import { generateKeys } from '../utils';
export const riskCategories = generateKeys({
    low: {
        value: 'low',
        label: 'Low',
    },
    medium: {
        value: 'medium',
        label: 'Medium',
    },
    normal: {
        value: 'normal',
        label: 'Normal',
    },
    high: {
        value: 'high',
        label: 'High',
    },
});
export const riskSubCategories = generateKeys({
    low: {
        value: 'low',
        label: 'Low',
    },
    medium: {
        value: 'medium',
        label: 'Medium',
    },
    high: {
        value: 'high',
        label: 'High',
    },
});
